import {NavLink, useNavigate} from "react-router-dom";
import React, {Fragment, useContext} from "react";
import {AuthContext} from "../../context/authContext";

const ClientUserMenuItems = () => {
  const navigate = useNavigate()
  const { logout } = useContext(AuthContext)

  const onLogout = (event) => {
    event.preventDefault()
    logout()
    // navigate('/')
  }

  return (
    <Fragment>
      <li className='nav-item'>
        <NavLink to="/my_account" className="nav-link dropdown-item close-nav">Profil</NavLink>
      </li>
      <li className='nav-item'>
        <NavLink to="/my_measurements" className="nav-link dropdown-item close-nav">Masuratori</NavLink>
      </li>
      {/*<li><NavLink to="/my_reports" className="nav-link dropdown-item close-nav">Rapoarte</NavLink></li>*/}
      <li className='nav-item'>
        <hr className="dropdown-divider" />
      </li>
      <li className='nav-item'>
        <NavLink to="/logout" onClick={onLogout} className="nav-link dropdown-item close-nav">Delogare</NavLink>
      </li>
    </Fragment>
  )
}
export default ClientUserMenuItems
